import getVideoHeightRatio from "app/media/helpers/getVideoHeightRatio";
import getWrapperStyles from "blocks/helpers/getWrapperStyles";
import VideoEmbed from "components/VideoEmbed/VideoEmbed";
import VideoViewer from "components/VideoViewer/VideoViewer";
import combineClasses from "helpers/combine-classes";
import React, { FunctionComponent } from "react";
import styles from "./Video.module.scss";
import VideoContent from "./VideoContent.model";

const Video: FunctionComponent<VideoContent> = (props) => {
    const wrapperStyles = getWrapperStyles(props.settings);
    const videoHeightRatio = getVideoHeightRatio(props.content.mediaCrop, "Widescreen (16:9)");

    const videoSizeClass = props.content.mediaSize ? styles[props.content.mediaSize] : undefined;
    const isAutoplay = props.content.autoplay ? props.content.autoplay : false;
    const isLoop = props.content.loop ? props.content.loop : false;
    const isSoundButton = props.content.soundButton ? props.content.soundButton : false;

    const randomNumber = Math.floor(Math.random() * 1000000);

    return (
        <div className={combineClasses([styles.wrapper, ...wrapperStyles, videoSizeClass])}>
            <div className={combineClasses([styles.container, videoSizeClass])}>
                <div className={styles.media}>
                    {/* Media */}
                    {props.content.media ? (
                        <VideoViewer
                            key={props.content.media.id + props.content.media.url}
                            src={props.content.media.url}
                            heightRatio={videoHeightRatio}
                            alt={props.content.mediaAlternate}
                            autoplay={isAutoplay}
                            loop={isLoop}
                            soundButton={isSoundButton}
                        />
                    ) : null}

                    {/* Video Embed */}
                    {props.content.videoUrl ? (
                        <VideoEmbed
                            soundButton={isSoundButton}
                            key={randomNumber}
                            className={styles.video}
                            src={props.content.videoUrl}
                            heightRatio={0.5625}
                            alt={props.content.mediaAlternate}
                            autoplay={isAutoplay}
                            loop={isLoop}
                        />
                    ) : null}

                    {/* Caption */}
                    {props.content.mediaCaption && props.content.mediaCaption.length > 0 ? (
                        <div className={styles.caption}>{props.content.mediaCaption}</div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Video;
